import { CartListProps } from "@/app/components/shopingCartComponent/CartList";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type ShopCartType = {
  /**购物车数量 */
  count: number;
  /**购物车数据 */
  shopCardsData: CartListProps[];
  /**是否是新加入商品 */
  isNew: boolean;
};

interface ShopCartState {
  shopCartInfo: ShopCartType;
  setShopCart: (value: object) => void;
  getShopCart: () => ShopCartType;
  removeShopCart: () => void;
}

const initialValue = {
  count: 0,
  shopCardsData:[],
  isNew:false
};

const shopCartStore = create<ShopCartState>()(
  persist(
    (set, get) => ({
      shopCartInfo: initialValue,
      setShopCart: (value: Partial<ShopCartType>) => {
        set({ shopCartInfo: { ...get().shopCartInfo, ...value } });
      },
      getShopCart: () => get().shopCartInfo,
      removeShopCart: () => set({ shopCartInfo: initialValue }),
    }),
    {
      name: "shopCart",
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
);

export default shopCartStore;
